export default __webpack_public_path__ + "static/media/plans.86e87028.jpg";